// extracted by mini-css-extract-plugin
export default {"root":"DepartmentPage_root__6Oa1k","tabs":"DepartmentPage_tabs__iWdV5","content":"DepartmentPage_content__QcsvR","tabsContainer":"DepartmentPage_tabsContainer__JVtlg"};